<!-- Side Structure -->
<template>
  <div
    class="sidebar"
    :class="sidebarSelectedFilter.class"
  >
    <vue-perfect-scrollbar
      class="scroll-area"
      :settings="settings"
    >
      <v-toolbar
        flat
        class="transparent scroll-area navigation"
      >
        <v-list>
          <app-logo></app-logo>
          <user-block></user-block>
          <template>
            <div>
              <div class="sidebar-title px-3">
                <span>Menu</span>
              </div>
              <template v-for="item in menus">
                <template v-if="item.items != null">
                  <v-list-group
                    :key="item.title"
                    prepend-icon="arrow_right"
                    append-icon=""
                    no-action
                    v-model="item.active"
                    v-if="!item['puedoModulo'] || $puedoModulo(item['puedoModulo'][0])"
                  >
                    <v-list-tile slot="activator">
                      <v-list-tile-content>
                        <v-list-tile-title v-if="item.items!= null">
                          <i
                            class="mr-3 zmdi"
                            :class="item.action"
                          ></i>
                          <span>{{ textTruncate((item.title)) }}</span>

                        </v-list-tile-title>

                      </v-list-tile-content>
                    </v-list-tile>
                    <template v-for="subItem in item.items">
                      <v-list-tile
                        :key="subItem.title"
                        @click="goTo(subItem)"
                        v-if="subItem !== null && (!subItem['puedo'] || $puedo(subItem['puedo'][0]))"
                      >

                        <v-list-tile-content>
                          <v-list-tile-title>{{ textTruncate((subItem.title))}}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list-group>
                </template>
                <template v-else>
                  <v-list-group
                    class="not-submenu"
                    :key="item.title"
                    prepend-icon="remove"
                    append-icon=""
                    no-action
                    v-model="item.active"
                    v-if="!item['puedoModulo'] || $puedoModulo(item['puedoModulo'][0])"
                  >
                    <v-list-tile slot="activator">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <router-link :to="item.path">
                            <i
                              class="mr-3 zmdi"
                              :class="item.action"
                            ></i>
                            <span>{{ textTruncate((item.title)) }}</span>
                          </router-link>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                  </v-list-group>
                </template>
              </template>
            </div>
          </template>
        </v-list>
      </v-toolbar>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import { textTruncate, getCurrentAppLayout } from 'Helpers/helpers'
import { mapGetters } from 'vuex'
import AppLogo from 'Components/AppLogo/AppLogo'
import UserBlock from './UserBlock'

export default {
  data () {
    return {
      settings: {
        maxScrollbarLength: 160
      }
    }
  },
  components: {
    UserBlock,
    AppLogo
  },
  computed: {
    ...mapGetters(['sidebarSelectedFilter', 'menus'])
  },
  methods: {
    textTruncate (text) {
      return textTruncate(text, 18)
    },
    getCurrentAppLayoutHandler () {
      return getCurrentAppLayout(this.$router)
    },
    goTo (item) {
      this.$router.push(item.path)
    }
  }
}
</script>
